module.exports = __webpack_public_path__ + "static/app-download-d46f29083607c9c92d8153028aecf9ae.jpg";